import type {Octicon, ProviderResponse} from '@github-ui/command-palette'
import {ServerDefinedItem, type ServerDefinedItemData} from '../items/server-defined-item'
import type {Query} from '../query'
import {ServerDefinedProvider} from './server-defined-provider'
import {getBaseFetchHeaders} from '@github-ui/fetch-headers'

export class RemoteProvider extends ServerDefinedProvider {
  override fetch(query: Query, _isEmpty: boolean): Promise<ProviderResponse> {
    return this.fetchSrc(query)
  }

  override enabledFor(query: Query): boolean {
    return this.modeMatch(query) && this.scopeMatch(query)
  }

  override clearCache(): void {
    // nothing to clear
  }

  scopeMatch(query: Query) {
    return this.scopeTypes.length === 0 || this.scopeTypes.includes(query.scope.type)
  }

  modeMatch(query: Query) {
    return this.modes.includes(query.mode) || this.hasWildCard
  }

  // Mark: - Protected methods

  protected async fetchSrc(query: Query, overrideMode = ''): Promise<ProviderResponse> {
    if (!this.src) throw new Error('No src defined')

    const url = new URL(this.src, window.location.origin)
    const params = query.params()

    if (overrideMode) {
      params.set('mode', overrideMode)
    }

    url.search = params.toString()
    const response = await fetch(url.toString(), {
      headers: {
        Accept: 'application/json',
        ...getBaseFetchHeaders(),
      },
    })

    if (response.ok) {
      const responseData: {results?: []; octicons?: Octicon[]} = await response.json()
      return {
        results:
          responseData.results?.map((itemData: ServerDefinedItemData) => ServerDefinedItem.build(itemData)) || [],
        octicons: responseData.octicons,
      }
    } else {
      return {error: true, results: []}
    }
  }
}
